import { t } from '@lingui/core/macro';
import { showToast } from 'state/toast';

export function handleDownloadError(notificationId: string, message?: string): void {
  showToast({ type: 'error', title: message || t`Failed to download image`, notificationId });
}
